module.exports = __webpack_public_path__ + "img/R2_4_research_matsumoto.155b3624.png";